import { type PropsWithChildren, useEffect, useState } from 'react'

/** Pulse status copy while visible, independently of the shared loading icon. */
export function LoadingText({ children }: PropsWithChildren) {
  const [visible, setVisible] = useState(!document.hidden)
  useEffect(() => {
    const update = () => setVisible(!document.hidden)
    document.addEventListener('visibilitychange', update)
    return () => document.removeEventListener('visibilitychange', update)
  }, [])
  return (
    <div
      className="loading-text"
      style={{ animationPlayState: visible ? 'running' : 'paused' }}
    >
      {children}
    </div>
  )
}
